import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconGenerativeStyle0 = gravityIconIndividualCss;

const GravityIconGenerative = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'a941436c995e01f6e52a896e0747ffbf2cc2c954', color: this.color, size: this.size }, h("svg", { key: 'd3e2bc334c0a74383d5ecfe7ea2d4f38c352a887', width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'bc7229dff440b4dbae7c9ddfe5e5212f591d69d1', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16 0c0 2.223 1.778 4 4 4-2.222 0-4 1.779-4 4 0-2.221-1.778-4-4-4 2.222 0 4-1.777 4-4ZM8.5 3c0 4.724 3.778 8.5 8.5 8.5-4.722 0-8.5 3.78-8.5 8.5 0-4.72-3.778-8.5-8.5-8.5 4.722 0 8.5-3.776 8.5-8.5Z", fill: "currentColor" }))));
    }
};
GravityIconGenerative.style = GravityIconGenerativeStyle0;

export { GravityIconGenerative as gravity_icon_generative };

//# sourceMappingURL=gravity-icon-generative.entry.js.map